import Vue from 'vue/dist/vue.esm'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import SystemMessageStore from './modules/system_message_store'
import SiteStore from './modules/site_store'
import UserStore from './modules/user_store'
import UserAuthStore from './modules/user_auth_store'
import LoaderStore from './modules/loader_store'
import PostEditor from './modules/post_editor'
import HtmlPageStore from './modules/html_page_store'
import I18n from './modules/i18n'
import TextLintStore from './modules/textlint_store'
import errorPage from './modules/errorPage'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersistence({
  strictMode: process.env.NODE_ENV !== 'production', // eslint-disable-line
  storage: window.localStorage,
  reducer: (state) => ({
    UserAuthStore: state.UserAuthStore
  }),
  filter: (mutation) =>
    mutation.type === 'UserAuthStore/setCurrentUserAuth' ||
    mutation.type === 'UserAuthStore/removeCurrentUserAuth'
})

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production', // eslint-disable-line
  modules: {
    SystemMessageStore,
    SiteStore,
    UserStore,
    UserAuthStore,
    LoaderStore,
    PostEditor,
    HtmlPageStore,
    I18n,
    TextLintStore,
    errorPage
  },
  mutations: {
    RESTORE_MUTATION: vuexLocalStorage.RESTORE_MUTATION
  },
  plugins: [vuexLocalStorage.plugin]
})
